import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { SaleHorseSetting } from '../../../../../models/sales/sale-horse-settings.model';
import { AuthService } from '../../../../../services/auth.service';
import { BaseUnsubscribeComponent } from '../../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../../../../shared-new/services/toast.service';

@Component({
  selector: 'app-approved-table',
  templateUrl: './approved-table.component.html',
  styleUrls: ['./approved-table.component.scss'],
})
export class ApprovedTableComponent
  extends BaseUnsubscribeComponent
  implements OnChanges
{
  @Input() dataSource: any[] = [];
  @Input() saleSettings: SaleHorseSetting = null;
  @Input() openButtonText: string = 'Open';
  @Input() headingText: string;
  @Input() enforceDeclaration: boolean = false;
  @Input() isViewXraysAllowed: boolean = false;
  @Input() viewXrayValidationMessage: string = '';
  isAllowedToView: boolean = false;
  loggedInMemberId: number = 0;
  @Input() showdocumentTypeName: boolean = false;

  @Output() openButtonClicked = new EventEmitter();
  @Output() downloadButtonClicked = new EventEmitter();
  @Output() deleteFileClicked = new EventEmitter();
  @Input() disclosedClient: string;  
  @Output() updateStatus = new EventEmitter();
  

  // The template renders a grid list rather than a mat-table, so there is no
  // displayedColumns to declare — the columns are the `--tr-file-cols` tracks,
  // shared with the label strip in approved-study.

  // dataSource: any = [];
  constructor(
    private authService: AuthService,
    private toastService: ToastService
  ) {
    super();
    // this.dataSource = [...this.studyFiles];
    this.authService
      .getUserData()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        const user = JSON.parse(data);
        this.loggedInMemberId = user.memberId;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['showdocumentTypeName']) {
    //   const documentTypeName =
    //     changes['showdocumentTypeName']?.currentValue;
    //   if (documentTypeName) {
    //     this.displayedColumns = [
    //       'submittedBy',
    //       'date',
    //       'details',
    //       'documentTypeName',
    //       'declare',
    //       'action',
    //     ];
    //   } else {
    //     this.displayedColumns = ['submittedBy', 'date', 'details', 'action'];
    //   }
    // }
    // const studyFiles = changes['studyFiles'];
    // if (studyFiles && studyFiles?.currentValue) {
    //   this.dataSource = new MatTableDataSource<StudyFile>(this.studyFiles);
    // }
  }
  // getStatusName(statusId: number): any {
  //   const selectedStatus = this.statuses.find(status => status.id === statusId);
  //   return selectedStatus ? selectedStatus.altName : "";
  // }
  onChangeStatus($event: any, studyFileIds: number[]): void {
    const statusId = $event?.target?.value;
    this.emitStatusUpdate(studyFileIds, statusId);
  }

  emitStatusUpdate(studyFileIds: number[], statusId: string): void {
    this.updateStatus.emit({ studyFileIds, statusId: parseInt(statusId) });
  }
  isSubmitter(studyFile: StudyFile) {
    if (studyFile.memberId == this.loggedInMemberId) {
      return true;
    }
    return false;
  }
  
  emitOpenButtonClicked(studyFile: any, form: FormGroup): void {
    this.openButtonClicked.emit({ studyFile, form });
  }

  emitDownloadButtonClicked(studyFileIds: number[]) : void {
    this.downloadButtonClicked.emit(studyFileIds);
  }

  emitDeleteButtonClicked(studyFileId: number): void {
    this.deleteFileClicked.emit(studyFileId);
  }

  isEnabledAction(element: any): boolean {    
    if (!this.saleSettings?.isViewingAllowed) {
      return false;
    }
    if((this.enforceDeclaration?? false) === false){
      return true;
    }
    if (this.disclosedClient !== null && this.disclosedClient !== '') {
      return true;
    }
    if (this.authService.IsSalesCompany()) {      
      return true;
    }    
    return false;
  }

  isSalesCompany(): boolean {
    return this.authService.IsSalesCompany();
  }

  isEnabledDeclarationTextBox() {
    return this.saleSettings?.isViewingAllowed;
  }

  transformData(
    studyFile: StudyFile,
    studyFileIds: number[]
  ): {
    studyFileIds: number[];
    submittedBy: string;
    date: string;
    imageCount: number;
    stamped: boolean;
    status: number;
    statusMessage: string;
  } {
    const model = {
      studyFileIds: studyFileIds,
      submittedBy: studyFile.createdByUser.name,
      date: studyFile.studyStatusDate,
      imageCount: studyFileIds.length,
      stamped: studyFile.isStamped,
      status: studyFile.studyStatusId,
      statusMessage: studyFile.statusMessage,
    };

    return model;
  }
}
